module.exports = __webpack_public_path__ + "img/banner_082401.e4edb32f.png";